// Azure Dev environment configuration
// ※このファイルはDEV環境（Azure）で使用されます
export const environment = {
  production: false,
  useApiGateway: false,  // DEV環境ではAPI Gatewayを使用しない（直接接続）
  // Login performance optimization: Use new authenticate-with-profile endpoint (1 API call instead of 2)
  // Set to false to rollback to old endpoint if needed
  // TODO: エンドポイント登録後にtrueに変更
  useNewLoginEndpoint: true,
  // SSO login performance optimization: Use new external-sso-authenticate-with-profile endpoint (1 API call instead of 2)
  // Set to false to rollback to old 2-API SSO flow (external-sso-authenticate + /user/details) if needed
  useNewSsoLoginEndpoint: true,
  // テスト期間フラグ: テスト期間中は true に変更して再デプロイ
  isTestPeriod: true,
  loginUrl: 'https://apigw-EU-DEV.manpowergroup.com/rest/v1/jp',
  // baseUrl: 'https://asj1jpu002.azurewebsites.net/api',
  baseUrl: 'https://dtuatapi.manpowergroup.jp/api',
  apiUrl: 'https://apigw-EU-DEV.manpowergroup.com/rest/v1/jp',
  apiGatewayUrl: 'https://apigw-EU-DEV.manpowergroup.com/rest/v1/jp/admin',
  apiGatewaySubscriptionKey: 'c24ed59bee274197adead61266bd665b',
  
  // API Gateway未登録カテゴリ(直接接続)
  // directApiUrl: 'https://asj1jpu002.azurewebsites.net/api',  // 直接接続用（フォールバック）
  directApiUrl: 'https://dtuatapi.manpowergroup.jp/api',  // 直接接続用（フォールバック）
  unregisteredAdminPaths: [] as string[], // 全体をAPIM経由とする場合は、経由させないadminパスを指定（例: ['/admin/ascreport']）
  
  ssoClientId: '03a0b8bc-c1b1-4a35-a564-4a1117b02f5f',
  ssoAuthUrl: 'https://login.microsoftonline.com/e2ba81b8-03fe-407c-96a1-f4bc0f512e7d/v2.0',
  ssoRedirectUrl: 'https://uat-dt.manpowergroup.jp/login-sso',
  // ssoApiUrl: 'https://asj1jpu002.azurewebsites.net/api',
  ssoApiUrl: 'https://dtuatapi.manpowergroup.jp/api',
  ssoApiId: 'api://59fc1e47-3510-4f91-9a93-a627b3b3f0c7/access_as_user'
};